// PT (pt-BR)
export const reservasSmallHc = {
  createAlerta: {
    title: "Criar novo lembrete",
    infoHeading: "Informações do lembrete",
    selectPropertyLabel: "Selecione a propriedade à qual deseja atribuir o lembrete",
    dayLabel: "Selecione um dia da semana:",
    dayMonday: "Segunda-feira",
    dayTuesday: "Terça-feira",
    dayWednesday: "Quarta-feira",
    dayThursday: "Quinta-feira",
    dayFriday: "Sexta-feira",
    daySaturday: "Sábado",
    daySunday: "Domingo",
    selectTimeLabel: "Selecione o horário",
    sendAtLabel: "Será enviado às:",
    minutesLabel: "Com {minutes} minutos:",
    previewPre: "O alerta será enviado aos hóspedes nas",
    previewMid: "às",
    descriptionLabel: "Descrição do alerta",
    descriptionPlaceholder: "Digite uma descrição para o alerta",
    messageTypeLabel: "Selecione o tipo de mensagem que será enviada.",
    messageTypeSimple: "Mensagem simples",
    messageTypeLink: "Mensagem com link no final",
    messageTypeFile: "Mensagem com arquivo anexado no final",
    linkFieldLabel: "Insira o link que será enviado com o lembrete",
    fileFieldLabel: "Carregue o arquivo que será enviado com o lembrete",
    fileNameLabel: "Nome do arquivo",
    cancel: "Cancelar",
    save: "Salvar lembrete",
    errorDayRequired: "O dia é obrigatório",
    errorTimeRequired: "O horário é obrigatório",
    errorSelectMinutes: "Selecione os minutos",
    errorDescriptionRequired: "A descrição é obrigatória",
    errorAttachmentRequired: "O anexo é obrigatório ou selecione que o tipo de mensagem seja simples",
  },
  reservationData: {
    statusConfirmed: "Confirmado",
    statusRejected: "Recusado",
    statusTentative: "Sujeito à disponibilidade",
    statusWithinCheckin: "Dentro do horário de check-in",
    statusFree: "Sem custo",
    modalTitleApprove: "Aprovar a solicitação?",
    modalTitleApproveTime: "Aprovar em outro horário?",
    modalTitlePrioritize: "Priorizar este check-in?",
    modalTitleReject: "Recusar a solicitação?",
    modalTitleDefault: "Confirmar?",
    modalTextApprove: "Você vai aprovar o check-in antecipado de",
    modalTextApproveTime: "Você confirmará o check-in no horário que indicar para",
    modalTextPrioritize: "Vamos dizer que vocês farão todo o possível para deixar tudo pronto nesse horário, mas que depende da saída anterior e da limpeza. Será enviado para",
    modalTextReject: "Você vai recusar o check-in antecipado de",
    modalTextDefault: "Confirmar para",
    modalCtaApprove: "Sim, aprovar",
    modalCtaApproveTime: "Confirmar horário",
    modalCtaPrioritize: "Sim, informar",
    modalCtaReject: "Sim, recusar",
    modalCtaDefault: "Confirmar",
    kpiRoom: "Quarto",
    kpiLodging: "Acomodação",
    guestsCount: "hóspede | hóspedes",
    adultsCount: "adulto | adultos",
    childrenCount: "criança | crianças",
    infantsCount: "bebê | bebês",
    roomsCountValue: "{count} quartos",
    holderRole: "Titular da reserva",
    noEmail: "Sem e-mail atribuído",
    writeWhatsapp: "Enviar mensagem no WhatsApp",
    noPhoneTitle: "Sem telefone não é possível enviar pelo WhatsApp. Você pode adicioná-lo em «Editar reserva».",
    noPhone: "Sem telefone atribuído",
    kpiCheckin: "Check-in",
    kpiCheckout: "Check-out",
    earlyRequested: "Check-in antecipado solicitado",
    arrivalRequested: "Horário de chegada solicitado",
    arrivesAt: "Chega às {time}",
    actionApprove: "Aprovar",
    actionOtherTime: "Outro horário",
    actionPrioritize: "Priorizar",
    actionReject: "Recusar",
    awaitingPayment: "À espera do pagamento do hóspede",
    cannotUndo: "Esta ação não pode ser desfeita.",
    checkinTimeLabel: "Horário de check-in",
    earlyPrioritisedTitle: "Check-in antecipado priorizado",
    earlyApprovedTitle: "Check-in antecipado aprovado",
    earlyRejectedTitle: "Check-in antecipado recusado",
    earlyLineApproved: "Chegará às {time}",
    earlyLineApprovedOther: "Chegará às {time} · pediu às {original}",
    earlyLineRejected: "Pediu às {time} · fará o check-in no horário habitual",
    earlyLineRejectedStd: "Pediu às {time} · fará o check-in no horário habitual ({std})",
    earlyLinePrioritised: "Quer chegar às {time} · dissemos que faremos o possível",
    extRequestedTitle: "Extensão da estadia pedida",
    extAwaitingTitle: "Extensão da estadia à espera do pagamento",
    extConfirmedTitle: "Extensão da estadia confirmada",
    extNights: "Noites adicionadas: {nights} · nova saída em {date}",
    extAtProperty: "{amount} a pagar no alojamento",
    extPendingHost: "à espera da sua aprovação",
    lateRequestedTitle: "Check-out tardio solicitado",
    lateAwaitingTitle: "Check-out tardio à espera do pagamento",
    lateConfirmedTitle: "Check-out tardio confirmado",
    lateRejectedTitle: "Check-out tardio recusado",
    lateLeavesAt: "Sai às {time}",
    lateWantsToLeave: "Quer sair às {time}",
    lateInsteadOf: "(em vez das {std})",
    latePaid: "Pago: {amount}",
    lateCourtesy: "Hora de cortesia, sem custo",
    lateFree: "Sem custo",
    lateCash: "{amount} em dinheiro à saída",
    lateUnpaid: "{amount}, ainda por pagar",
    lateLineRejected: "Pediu para sair às {time} · sai à hora habitual",
    lateLineRejectedStd: "Pediu para sair às {time} · sai à hora habitual ({std})",
    requestedTimeHint: "O hóspede pediu às {time}",
    toastApproved: "Check-in antecipado aprovado",
    toastApprovedTime: "Novo horário de entrada aprovado",
    toastPrioritised: "Check-in antecipado priorizado",
    toastRejected: "Check-in antecipado recusado",
    toastNotified: "Já avisamos o hóspede.",
    toastNotNotified: "Não foi possível avisar o hóspede: escreva para ele.",
    toastAlreadyDecided: "Esta solicitação já estava decidida: o hóspede não foi avisado de novo.",
    toastError: "Não foi possível salvar a decisão. Tente novamente.",
    toastAlreadyPaid: "Já estava paga: não foi cobrado de novo.",
    toastRefundMaybeDue: "Pagou para entrar antes e agora entra no horário normal: se for o caso, devolva o valor.",
    actionReadyNow: "Já pode entrar",
    actionNotPossible: "Não vai ser possível",
    toastPaymentLinkFailed: "Não foi possível criar o link de pagamento: cobre de outra forma.",
    arrivalApprovedTitle: "Horário de chegada confirmado",
    arrivalRejectedTitle: "Horário de chegada recusado",
    arrivalLineRejected: "Pediu para chegar às {time}",
    modalTextApproveArrival: "Você vai confirmar o horário de chegada de",
    modalTextRejectArrival: "Você vai recusar o horário de chegada de",
    toastArrivalApproved: "Horário de chegada confirmado",
    toastArrivalRejected: "Horário de chegada recusado",
    cancel: "Cancelar",
  },
  minStayModal: {
    summaryNoData: "Sem dados no intervalo selecionado",
    summaryHintMixed: "Foram detectadas várias estadias mínimas no intervalo. O campo é definido como 1 noite para que você defina o novo valor.",
    summaryHintSingle: "O campo foi carregado com a estadia mínima atual do intervalo selecionado.",
    errorMinOne: "A estadia mínima deve ser de pelo menos 1 noite.",
    opStartLabel: "Alterando estadia mínima…",
    successUpdated: "Estadia mínima atualizada com sucesso",
    errorUpdate: "Erro ao atualizar a estadia mínima",
    errorUnknown: "Erro desconhecido",
    title: "Estadia mínima",
    description: "Defina a estadia mínima de noites para o intervalo de datas selecionado.",
    detectedLabel: "Estadias mínimas detectadas",
    minStayLabel: "Estadia mínima (noites)",
    decreaseAria: "Diminuir estadia mínima",
    minNightsPlaceholder: "Ex: 2",
    increaseAria: "Aumentar estadia mínima",
    hint: "Número mínimo de noites que o hóspede deve reservar.",
    cancel: "Cancelar",
    save: "Salvar",
  },
  modalCompleteReservation: {
    errorContactRequired: "Para continuar você deve preencher um dos dois campos (telefone ou e-mail)",
    successMsg: "Dados da reserva concluídos com sucesso",
    successTitle: "Processo concluído com sucesso",
    title: "Concluir reserva",
    bookingDateLabel: "Datas da reserva",
    checkin: "Check-in",
    checkout: "Check-out",
    phoneRequiredHint: "* Único campo obrigatório",
    emailHint: "*Se você informar o e-mail, o cliente não precisará digitá-lo",
    responsibleLabel: "Digite o nome do responsável",
    responsiblePlaceholder: "Responsável pela reserva",
    scheduleLabel: "Programe a data de envio do link de check-in.",
    scheduleAuto: "Envio automático",
    schedule24: "24 horas antes do check-in",
    schedule48: "48 horas antes do check-in",
    schedule72: "72 horas antes do check-in",
    scheduleWeek: "Uma semana antes do check-in",
    cancel: "Cancelar",
    complete: "Concluir reserva",
  },
  payData: {
    errorNoPaymentRecord: "Não foi possível identificar o registro de pagamento.",
    partialLinkGenerated: "Link de cobrança gerado com sucesso.",
    errorGenerateLink: "Não foi possível gerar o link.",
    partialRegistered: "Pagamento parcial registrado.",
    errorSavePartial: "Não foi possível salvar o pagamento parcial.",
    whatsappPartialMsg: "Olá {name}, compartilhamos o link para concluir o pagamento pendente da sua reserva: {url}",
    errorInvoicingNotActive: "O faturamento eletrônico não está ativado no seu plano.",
    fieldBillingProfile: "Perfil de faturamento",
    fieldCountry: "País",
    fieldLegalName: "Razão social",
    fieldTaxId: "NIF/CIF/NIT",
    fieldAddressStreet: "Endereço",
    fieldAddressCity: "Cidade",
    fieldAddressRegion: "Estado",
    fieldAddressZip: "CEP",
    fieldEmail: "E-mail",
    fieldIsActive: "Ativar perfil",
    errorBillingIncomplete: "Complete seus dados de faturamento. Faltam: {fields}",
    invoiceLinkCopied: "Link de faturamento copiado.",
    reservationHasInvoice: "Esta reserva já tem fatura.",
    errorLoadReceipt: "Não foi possível carregar o recibo.",
    errorDownloadReceipt: "Não foi possível baixar o recibo.",
    guestOutOfWindow: "O hóspede está fora da janela de 24h do WhatsApp.",
    errorSendReceipt: "Erro ao enviar o recibo.",
    charge: "Cobrança",
    lodging: "Acomodação",
    servicesExtras: "Serviços e extras",
    free: "Grátis",
    ivaIncluded: "(IVA {rate}% incluído)",
    includedInPrice: "(incluído no preço)",
    pendingCharge: "Pagamento pendente",
    viewBreakdown: "Ver detalhamento de preços",
    viewReceipt: "Ver recibo",
    receiptInfoPre: "Recibo informativo. A fatura eletrônica é emitida na aba",
    chargesTab: "Cobranças",
    receiptInfoNoInvoice: "Recibo informativo disponível. Para faturamento eletrônico, configure seus dados de faturamento.",
    reservationNumber: "Reserva #{code}",
    currentStatus: "Status atual",
    willChangeTo: "Mudará para:",
    saving: "Salvando…",
    breakdownTitle: "Detalhamento de preços",
    discounts: "Descontos",
    taxesAndFees: "Impostos e taxas",
    ivaIncludedInPrice: "IVA ({rate}%) incluído no preço: {amount}",
    includesTaxes: "Inclui {amount} de impostos incluídos no preço",
    total: "Total",
    close: "Fechar",
    loadingReceipt: "Carregando recibo…",
    stayReceipt: "Recibo da estadia · {date}",
    downloadPdf: "Baixar PDF",
    sending: "Enviando…",
    sent: "Enviado!",
    outOfWindow: "Fora da janela de 24h",
    sendWhatsapp: "Enviar pelo WhatsApp",
    stayDetail: "Detalhes da estadia",
    ivaIncludedShort: "IVA {rate}% incluído",
    discount: "Desconto",
    nightsCount: "noite | noites",
    additionalCharges: "Cobranças adicionais",
    ivaShort: "IVA {rate}%",
    charged: "Recebido",
    pending: "Pendente",
    receiptGeneratedBy: "Recibo gerado por",
    done: "Concluído",
    registerPartial: "Registrar pagamento parcial",
    reservationTotal: "Total da reserva",
    amountReceived: "Valor já recebido",
    paid: "Pago",
    pendingBalance: "Saldo pendente",
    amountExceedsTotal: "O valor recebido excede o total. Use o status",
    paidStatus: "Pago",
    internalNote: "Nota interna",
    optional: "(opcional)",
    notePlaceholder: "Ex: Primeiro pagamento recebido por transferência...",
    autoLinkNote: "Ao salvar, o link de pagamento será atualizado automaticamente para",
    cancel: "Cancelar",
    savePartial: "Salvar pagamento parcial",
    roomsCount: "{count} quarto | {count} quartos",
    groupNotePre: "Valor da",
    groupNoteCombined: "reserva combinada",
    groupNoteMid: "detalhamento por quarto abaixo.",
  },
};
